/* =================================
   SHOPIFY NATIVE LOCATION BANNERS
   Reads banner config from theme settings
   ================================= */

// Shopify-native location banner system
window.ShopifyLocationBanners = {
  
  currentStoreId: null,
  containersInitialized: false,
  initialized: false,
  
  /**
   * Initialize the banner system
   */
  init: function() {
    // Prevent double initialization
    if (this.initialized) {
      console.log('🔄 Shopify Location Banners already initialized, skipping...');
      return;
    }
    
    console.log('🎯 Initializing Shopify Location Banners...');
    this.initialized = true;
    
    // Get current store ID from global variable or URL
    this.currentStoreId = this.getCurrentStoreId();
    
    if (!this.currentStoreId) {
      console.log('📍 No store selected - banners will show when store is chosen');
      return;
    }
    
    console.log(`🏪 Current store: ${this.currentStoreId}`);
    
    // Initialize banner containers
    this.initializeContainers();
    
    // Display banners for current store
    this.displayBannersForStore(this.currentStoreId);
    
    // Listen for store changes
    this.watchForStoreChange();
  },
  
  /**
   * Get current store ID from various sources
   */
  getCurrentStoreId: function() {
    // Try global variable first (set by theme)
    if (window.storeId) {
      return window.storeId.toString();
    }
    
    // Try URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const locationId = urlParams.get('locationid');
    if (locationId) {
      return locationId;
    }
    
    // Try cookie
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'store_id' && value) {
        return value;
      }
    }
    
    return null;
  },
  
  /**
   * Initialize banner containers
   */
  initializeContainers: function() {
    if (this.containersInitialized) return;
    
    // Look for existing banner containers (including section containers)
    let containers = document.querySelectorAll('.location-banner-container, #location-banners, [id^="location-banners-"]');
    
    // If no containers exist, create one at the top of main content
    if (containers.length === 0) {
      const mainContent = document.querySelector('main') || document.querySelector('#main') || document.querySelector('.main-content') || document.body;
      
      if (mainContent) {
        const container = document.createElement('div');
        container.id = 'location-banners';
        container.className = 'location-banner-container';
        
        // Insert at the beginning of main content
        mainContent.insertBefore(container, mainContent.firstChild);
        containers = [container];
        
        console.log('📦 Created banner container');
      }
    }
    
    console.log(`📦 Found ${containers.length} banner container(s)`);
    this.containersInitialized = true;
  },
  
  /**
   * Get banner configuration for a specific store from Shopify settings
   */
  getBannerConfigForStore: function(storeId) {
    // Map store IDs to setting prefixes
    const storeSettingMap = {
      '3782': 'walker',
      '3781': 'mill_creek', 
      '3779': 'capilano',
      '3784': 'beaches'
    };
    
    const settingPrefix = storeSettingMap[storeId];
    if (!settingPrefix) {
      console.log(`❌ No banner configuration found for store ${storeId}`);
      return null;
    }
    
    // Check if Shopify settings are available
    if (!window.ShopifyThemeSettings) {
      console.warn('⚠️ Shopify theme settings not available - using fallback');
      return this.getFallbackBanner(storeId);
    }
    
    const settings = window.ShopifyThemeSettings;
    
    // Check if banner is enabled for this store
    const enabledKey = `${settingPrefix}_banner_enabled`;
    if (!settings[enabledKey]) {
      console.log(`📴 Banner disabled for store ${storeId}`);
      return null;
    }
    
    // Build banner configuration from settings
    const title = settings[`${settingPrefix}_banner_title`] || '';
    const message = settings[`${settingPrefix}_banner_message`] || '';
    const image = settings[`${settingPrefix}_banner_image`];
    
    // Require at least title, message, OR image
    if (!title && !message && !image) {
      console.log(`⚠️ No content configured for store ${storeId}`);
      return null;
    }
    
    const banner = {
      id: `shopify-${storeId}-banner`,
      title: title,
      message: message,
      actionText: settings[`${settingPrefix}_banner_action_text`] || 'Shop Now',
      actionUrl: settings[`${settingPrefix}_banner_action_url`] || '#',
      backgroundColor: settings[`${settingPrefix}_banner_bg_color`] || '#660eae',
      textColor: settings[`${settingPrefix}_banner_text_color`] || '#ffffff',
      backgroundImage: image,
      imagePosition: settings[`${settingPrefix}_banner_image_position`] || 'background',
      overlayOpacity: (settings[`${settingPrefix}_banner_overlay_opacity`] || 0) / 100,
      buttonPosition: settings[`${settingPrefix}_banner_button_position`] || 'right',
      titleColor: settings[`${settingPrefix}_banner_title_color`] || '#ffffff',
      contentPosition: settings[`${settingPrefix}_banner_content_position`] || 'left',
      buttonBackgroundColor: settings[`${settingPrefix}_banner_button_bg_color`] || 'rgba(255, 255, 255, 0.2)',
      buttonTextColor: settings[`${settingPrefix}_banner_button_text_color`] || '#ffffff',
      newTab: settings[`${settingPrefix}_banner_new_tab`] || false,
      titleFontSize: settings[`${settingPrefix}_banner_title_font_size`] || 'medium',
      titleStyle: settings[`${settingPrefix}_banner_title_style`] || '',
      messageFontSize: settings[`${settingPrefix}_banner_message_font_size`] || 'medium',
      messageStyle: settings[`${settingPrefix}_banner_message_style`] || '',
      buttonBorderWidth: settings[`${settingPrefix}_banner_button_border_width`] || 1,
      buttonBorderColor: settings[`${settingPrefix}_banner_button_border_color`] || 'rgba(255, 255, 255, 0.3)',
      buttonShadow: settings[`${settingPrefix}_banner_button_shadow`] || false,
      buttonRadius: settings[`${settingPrefix}_banner_button_radius`] || 4,
      startDate: '2024-01-01', // Always active since controlled by admin enable/disable
      endDate: '2026-12-31',
      priority: 1
    };
    
    console.log(`✅ Retrieved banner config for store ${storeId}:`, banner);
    return banner;
  },
  
  /**
   * Fallback banner configuration (in case settings aren't loaded)
   */
  getFallbackBanner: function(storeId) {
    if (storeId === '3781') {
      return {
        id: 'fallback-mill-creek',
        title: 'Grand Opening Special!',
        message: 'Celebrate our Mill Creek location with 20% off your entire purchase!',
        actionText: 'Shop Now',
        actionUrl: '/collections/specials',
        backgroundColor: '#660eae',
        textColor: '#ffffff',
        startDate: '2024-01-01',
        endDate: '2026-12-31',
        priority: 1
      };
    }
    return null;
  },
  
  /**
   * Display banners for specific store
   */
  displayBannersForStore: function(storeId) {
    console.log(`🎯 Displaying banners for store ${storeId}`);
    
    // Get banner configuration
    const banner = this.getBannerConfigForStore(storeId);
    
    // Clear existing banners
    this.clearBanners();
    
    if (!banner) {
      console.log(`📭 No banners to display for store ${storeId}`);
      return;
    }
    
    // Create and display banner
    this.createAndDisplayBanner(banner);
  },
  
  /**
   * Clear all banners
   */
  clearBanners: function() {
    const containers = document.querySelectorAll('.location-banner-container, #location-banners, [id^="location-banners-"]');
    containers.forEach(container => {
      container.innerHTML = '';
    });
  },
  
  /**
   * Create and display a banner
   */
  createAndDisplayBanner: function(banner) {
    const containers = document.querySelectorAll('.location-banner-container, #location-banners, [id^="location-banners-"]');
    
    if (containers.length === 0) {
      console.warn('⚠️ No banner containers found');
      return;
    }
    
    const bannerElement = this.createBannerElement(banner);
    
    containers.forEach(container => {
      const clonedBanner = bannerElement.cloneNode(true);
      container.appendChild(clonedBanner);
    });
    
    console.log(`✅ Banner displayed: ${banner.title}`);
  },
  
  /**
   * Create a banner DOM element
   */
  createBannerElement: function(banner) {
    const bannerDiv = document.createElement('div');
    bannerDiv.className = 'location-banner';
    bannerDiv.setAttribute('data-store-id', this.currentStoreId);
    bannerDiv.setAttribute('data-banner-id', banner.id);
    
    // Set styling
    let styles = `
      background-color: ${banner.backgroundColor};
      color: ${banner.textColor};
    `;
    
    // Handle background image
    if (banner.backgroundImage && banner.imagePosition === 'background') {
      const imageUrl = banner.backgroundImage.includes('http') ? banner.backgroundImage : banner.backgroundImage;
      
      // Only add overlay if opacity is greater than 0
      if (banner.overlayOpacity && banner.overlayOpacity > 0) {
        styles += `
          background-image: linear-gradient(rgba(0,0,0,${banner.overlayOpacity}), rgba(0,0,0,${banner.overlayOpacity})), url('${imageUrl}');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        `;
      } else {
        styles += `
          background-image: url('${imageUrl}');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        `;
      }
    }
    
    bannerDiv.style.cssText = styles;
    
    // Build banner content
    let contentHTML = '';
    
    if (banner.backgroundImage && banner.imagePosition !== 'background') {
      // Side image layout
      bannerDiv.classList.add('banner-with-side-image');
      
      const imageHTML = (banner.buttonPosition === 'none' && banner.actionUrl && banner.actionUrl !== '#') ? 
        `<a href="${banner.actionUrl}"${banner.newTab ? ' target="_blank"' : ''} class="banner-image-link"><img class="banner-image" src="${banner.backgroundImage}" alt="${banner.title || 'Banner image'}" style="cursor: pointer;"></a>` :
        `<img class="banner-image" src="${banner.backgroundImage}" alt="${banner.title || 'Banner image'}">`;
      const buttonHTML = (banner.buttonPosition !== 'none' && banner.actionUrl && banner.actionUrl !== '#') ? 
        `<a href="${banner.actionUrl}" class="banner-action banner-button-${banner.buttonPosition}${banner.buttonShadow ? ' has-shadow' : ''}" style="background-color: ${banner.buttonBackgroundColor}; color: ${banner.buttonTextColor}; border-width: ${banner.buttonBorderWidth}px; border-color: ${banner.buttonBorderColor}; border-radius: ${banner.buttonRadius}px;"${banner.newTab ? ' target="_blank"' : ''}>${banner.actionText}</a>` : '';
      
      const textHTML = `
        <div class="banner-text-content" style="text-align: ${banner.contentPosition};">
          ${banner.title ? `<h3 class="banner-title${banner.titleFontSize ? ' font-' + banner.titleFontSize : ''}${banner.titleStyle ? ' style-' + banner.titleStyle : ''}" style="color: ${banner.titleColor};">${banner.title}</h3>` : ''}
          ${banner.message ? `<p class="banner-message${banner.messageFontSize ? ' font-' + banner.messageFontSize : ''}${banner.messageStyle ? ' style-' + banner.messageStyle : ''}">${banner.message}</p>` : ''}
          ${banner.buttonPosition === 'center' ? buttonHTML : ''}
        </div>
        ${(banner.buttonPosition === 'left' || banner.buttonPosition === 'right') ? buttonHTML : ''}
      `;
      
      contentHTML = `
        <div class="banner-content ${banner.imagePosition === 'left' ? 'image-left' : 'image-right'}">
          ${banner.imagePosition === 'left' ? imageHTML + textHTML : textHTML + imageHTML}
        </div>
      `;
    } else {
      // Background image or no image layout
      if (banner.backgroundImage && banner.imagePosition === 'background') {
        bannerDiv.classList.add('banner-with-bg-image');
      }
      
      const buttonHTML = (banner.buttonPosition !== 'none' && banner.actionUrl && banner.actionUrl !== '#') ? 
        `<a href="${banner.actionUrl}" class="banner-action banner-button-${banner.buttonPosition}${banner.buttonShadow ? ' has-shadow' : ''}" style="background-color: ${banner.buttonBackgroundColor}; color: ${banner.buttonTextColor}; border-width: ${banner.buttonBorderWidth}px; border-color: ${banner.buttonBorderColor}; border-radius: ${banner.buttonRadius}px;"${banner.newTab ? ' target="_blank"' : ''}>${banner.actionText}</a>` : '';
      
      contentHTML = `
        <div class="banner-content">
          <div class="banner-text-content" style="text-align: ${banner.contentPosition};">
            ${banner.title ? `<h3 class="banner-title${banner.titleFontSize ? ' font-' + banner.titleFontSize : ''}${banner.titleStyle ? ' style-' + banner.titleStyle : ''}" style="color: ${banner.titleColor};">${banner.title}</h3>` : ''}
            ${banner.message ? `<p class="banner-message${banner.messageFontSize ? ' font-' + banner.messageFontSize : ''}${banner.messageStyle ? ' style-' + banner.messageStyle : ''}">${banner.message}</p>` : ''}
            ${banner.buttonPosition === 'center' ? buttonHTML : ''}
          </div>
          ${(banner.buttonPosition === 'left' || banner.buttonPosition === 'right') ? buttonHTML : ''}
        </div>
      `;
    }
    
    bannerDiv.innerHTML = contentHTML;
    
    // Banner clickability removed per user request
    
    return bannerDiv;
  },
  
  /**
   * Watch for store ID changes
   */
  watchForStoreChange: function() {
    // Watch for window.storeId changes
    let lastStoreId = this.currentStoreId;
    
    setInterval(() => {
      const newStoreId = this.getCurrentStoreId();
      if (newStoreId !== lastStoreId) {
        console.log(`🔄 Store changed from ${lastStoreId} to ${newStoreId}`);
        lastStoreId = newStoreId;
        this.currentStoreId = newStoreId;
        
        if (newStoreId) {
          this.displayBannersForStore(newStoreId);
        } else {
          this.clearBanners();
        }
      }
    }, 1000);
    
    // Also listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', () => {
      setTimeout(() => {
        const newStoreId = this.getCurrentStoreId();
        if (newStoreId !== this.currentStoreId) {
          this.currentStoreId = newStoreId;
          if (newStoreId) {
            this.displayBannersForStore(newStoreId);
          } else {
            this.clearBanners();
          }
        }
      }, 100);
    });
  },
  
  /**
   * Refresh banners (useful after settings changes)
   */
  refresh: function() {
    console.log('🔄 Refreshing location banners...');
    if (this.currentStoreId) {
      this.displayBannersForStore(this.currentStoreId);
    }
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Small delay to ensure other scripts have loaded
  setTimeout(() => {
    window.ShopifyLocationBanners.init();
  }, 500);
});

// Also initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  // DOM is still loading, wait for DOMContentLoaded
} else {
  // DOM is already loaded
  setTimeout(() => {
    window.ShopifyLocationBanners.init();
  }, 500);
}

// Expose useful functions globally
window.refreshLocationBanners = function() {
  if (window.ShopifyLocationBanners) {
    window.ShopifyLocationBanners.refresh();
  }
};

console.log('🎯 Shopify Location Banners system loaded');